// Pure helpers for the occupation Searcher. Extracted from Searcher.jsx so they
// can be unit tested without a DOM/JSX harness.

/**
 * Decide which occupations should pass the typeahead filter for `value`.
 *
 * A matching occupation is kept, and so are all of its ancestors (so filtering
 * doesn't strand a category without its parent chain). Children of matches are
 * NOT kept unless they match themselves.
 *
 * @returns {Object<string, boolean>} map of occupation title -> keep
 */
export function getKeepers (options, value) {
  let keepers = {}
  function keepUp (occupation) {
    keepers[occupation.title] = true

    if (occupation.parent) {
      keepUp(occupation.parent)
    }
  }

  function keepDown (occupation) {
    keepers[occupation.title] = true

    let children = Object.values(occupation.children)
    if (children.length) {
      children.forEach(keepDown)
    }
  }

  options.forEach(occupation => {
    // if we've already marked this as good, don't do anything more
    if (keepers[occupation.title] === true) {
      return
    }

    // default to false
    keepers[occupation.title] = false

    if ((occupation.title.toLowerCase()).includes(value.toLowerCase())) {
      keepUp(occupation)
      // not sure we want to keep down; makes it harder to find specifics
      // keepDown(occupation)
    }
  })

  return keepers
}

/**
 * Build the subtitle lines shown under an occupation in the Searcher dropdown:
 * subcategory/occupation counts and a domination summary (if any).
 *
 * @returns {string[]}
 */
export function buildOptionSubtitle (option) {
  let subtitle = []
  let subjobs = []

  if (option.subcategories) {
    subjobs.push(`${option.subcategories} subcategories`)
  }
  if (option.occupations) {
    subjobs.push(`${option.occupations} occupations`)
  }

  if (subjobs.length) {
    subtitle.push(subjobs.join(', '))
  }

  if (option.dominationAverage) {
    if (option.dominationAverage > 20) {
      subtitle.push(`male dominated (+${Math.round(option.dominationAverage)}%) (confidence: ${option.confidenceScore})`)
    } else if (option.dominationAverage > 0) {
      subtitle.push(`male leading (+${Math.round(option.dominationAverage)}%) (confidence: ${option.confidenceScore})`)
    } else if (option.dominationAverage < -20) {
      subtitle.push(`female dominated (+${-Math.round(option.dominationAverage)}%) (confidence: ${option.confidenceScore})`)
    } else if (option.dominationAverage < 0) {
      subtitle.push(`female leading (+${-Math.round(option.dominationAverage)}%) (confidence: ${option.confidenceScore})`)
    }
  }

  return subtitle
}
